import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cb24c32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NotificationsIt" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center mt-3 bg-white rounded py-3 px-4"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Загрузка списка...", -1))
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "flex items-center justify-end bg-white rounded py-3 px-4" }
const _hoisted_7 = { class: "overflow-hidden overflow-x-auto" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-building" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "fas mr-2 fa-toggle-on"
}
const _hoisted_11 = {
  key: 1,
  class: "fas mr-2 fa-toggle-off"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_update_templates_modal = _resolveComponent("update-templates-modal")!
  const _component_update_companies_modal = _resolveComponent("update-companies-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state_update_template.is_open)
      ? (_openBlock(), _createBlock(_component_update_templates_modal, {
          key: 0,
          id: _ctx.state_update_template.id,
          onCancel: _ctx.toggleTemplate,
          onUpdated: _ctx.onTemplateUpdated
        }, null, 8, ["id", "onCancel", "onUpdated"]))
      : _createCommentVNode("", true),
    (_ctx.state_update_companies.is_open)
      ? (_openBlock(), _createBlock(_component_update_companies_modal, {
          key: 1,
          id: _ctx.state_update_companies.id,
          onCancel: _ctx.toggleCompany,
          onUpdated: _ctx.loadSettings
        }, null, 8, ["id", "onCancel", "onUpdated"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "Настройки" }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.state.settings.is_failed && !_ctx.state.settings.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.settings.is_loading,
            text: "При получении списка графиков произошла ошибка",
            "error-message": _ctx.state.settings.failure.error_state.message,
            "error-url": _ctx.state.settings.failure.error_state.url,
            "error-status": _ctx.state.settings.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadSettings(_ctx.state.settings.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_ctx.state.settings.is_loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_loader, { class: "primary mr-1" }),
              _hoisted_4
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_new_limit, {
                  disabled: _ctx.state.settings.is_loading,
                  value: _ctx.state.limit,
                  "total-items": _ctx.state.settings.pagination.total_items,
                  onChange: _ctx.onLimitChange
                }, null, 8, ["disabled", "value", "total-items", "onChange"]),
                _createVNode(_component_new_pagination, {
                  class: "ml-6",
                  disabled: _ctx.state.settings.is_loading,
                  "current-page": _ctx.state.settings.pagination.current_page,
                  "total-pages": _ctx.state.settings.pagination.total_pages,
                  onChangePage: _ctx.onChangePage
                }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_new_table, {
                  columns: _ctx.NotificationItColumns,
                  rows: _ctx.state.settings.list
                }, {
                  td: _withCtx(({ column, row }) => [
                    (column.key === 'description')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.cut(row.description, 15)), 1)
                        ], 64))
                      : (column.key === 'companiesString')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.cut(_ctx.getCompanies(row.companies), 15)), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                          ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    (_ctx.isCanEditCompanies)
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          hint: "Редактировать компании",
                          class: "yellow extra-small",
                          loading: _ctx.state.is_loading,
                          onClick: ($event: any) => (_ctx.toggleCompany(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isCanEditTemplates)
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 1,
                          hint: "Редактировать шаблоны",
                          class: "yellow extra-small ml-2",
                          loading: _ctx.state.is_loading,
                          onClick: ($event: any) => (_ctx.toggleTemplate(row))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isCanEditCompanies)
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 2,
                          loading: _ctx.state.is_active_loading,
                          class: "primary text small",
                          onClick: ($event: any) => (_ctx.manageActiveBtn(row))
                        }, {
                          default: _withCtx(() => [
                            (row.isActive)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                              : (_openBlock(), _createElementBlock("i", _hoisted_11)),
                            _createTextVNode(" " + _toDisplayString(_ctx.getActiveBtnText(row)), 1)
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ]))
    ])
  ]))
}